import { render } from "./TelaMenu.vue?vue&type=template&id=47579dab&scoped=true"
import script from "./TelaMenu.vue?vue&type=script&lang=js"
export * from "./TelaMenu.vue?vue&type=script&lang=js"

import "./TelaMenu.vue?vue&type=style&index=0&id=47579dab&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47579dab"]])

export default __exports__